/** Path prefix the legacy v1 app is mounted at; this app owns everything else. */
const V1_PREFIX = "/app";

/**
 * During the migration two apps share one domain. The router enforces that split on real requests,
 * but an in-app navigation only pushState's, so it never sees one — these guards do the same job
 * from the client.
 */
export const belongsToOtherApp = (pathname: string) => pathname.startsWith(V1_PREFIX);

/** Hand a URL back to the browser, then halt: the page is unloading and must not render meanwhile. */
export const leaveNow = (url = window.location.pathname + window.location.search): Promise<never> => {
  window.location.assign(url);
  return new Promise<never>(() => {});
};

/**
 * Which stack serves a building is a routing decision, not a property the app can read. Ask the
 * router with a real request and follow the answer; staying put would render another stack's data.
 *
 * Skip on intent preload: this calls `leaveNow` (`location.assign`). Hovering a map pin would
 * otherwise dump the user into a v1 building without a click.
 */
export const leaveIfOtherStack = async (path: string, preload?: boolean): Promise<void> => {
  if (preload) return;
  const response = await fetch(path, { method: "HEAD" });
  if (response.redirected) await leaveNow(response.url);
};
